import React from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "../../services/ProtectedRoute";

/**
 * Helper para construir rutas de manera declarativa
 * Simplifica la creación de rutas protegidas y públicas
 */
export const RouteBuilder = {
  /**
   * Crea una ruta protegida
   * @param {string} path - Ruta del componente
   * @param {React.Component} element - Componente a renderizar
   * @param {number[]} roles - Roles permitidos (1=Admin, 2=Inspector, 3=Supervisor, 4=Supervisor2, 5=Developer, 6=General, 7=RH, 8=Instalación)
   * @param {string} key - Key única (opcional, usa path por defecto)
   */
  protected: (path, element, roles, key = null) => (
    <Route
      key={key || path}
      path={path}
      element={<ProtectedRoute element={element} requiredRole={roles} />}
    />
  ),

  /**
   * Crea una ruta pública
   * @param {string} path - Ruta del componente
   * @param {React.Component} element - Componente a renderizar
   * @param {string} key - Key única (opcional, usa path por defecto)
   */
  public: (path, element, key = null) => (
    <Route key={key || path} path={path} element={element} />
  ),
};

/**
 * Convierte un array de definiciones de rutas a componentes Route
 * @param {Array} routeDefinitions - Array de objetos con { path, element, roles?, public? }
 * @returns {Array<Route>} Array de componentes Route
 */
export const buildRoutes = (routeDefinitions) => {
  return routeDefinitions.map((route, index) => {
    const key = route.key || `${route.path}-${index}`;

    if (route.public) {
      return RouteBuilder.public(route.path, route.element, key);
    }

    return RouteBuilder.protected(route.path, route.element, route.roles, key);
  });
};

export default RouteBuilder;
